import { Box, BoxProps, Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { HiOutlineSparkles } from "react-icons/hi2";

interface AskInputTriggerProps extends BoxProps {
  onClick: () => void;
  placeholder?: string;
}

/**
 * A "fake input" trigger that looks like a text input but is actually
 * a clickable button. Used to trigger the Ask Assistant panel.
 */
export const AskInputTrigger: React.FC<AskInputTriggerProps> = ({
  onClick,
  placeholder = "Ask me anything about this conversation...",
  ...props
}) => {
  return (
    <Box
      bg="linear-gradient(99deg, #0074DD66 -2.93%, #591EFF66 58.85%, #9644FF66 126.18%), #FFF;"
      padding="4"
      {...props}
    >
      <Flex
        as="button"
        type="button"
        onClick={onClick}
        alignItems="center"
        gap={3}
        w="100%"
        px={4}
        py={4}
        bg="white"
        borderRadius="md"
        cursor="text"
        _hover={{
          bg: "gray.100",
        }}
        transition="background 0.15s ease"
      >
        <Icon as={HiOutlineSparkles} color="purple.600" boxSize={5} />
        <Text color="gray.500" fontSize="sm">
          {placeholder}
        </Text>
      </Flex>
    </Box>
  );
};
